// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__o8_cI","top":"styles_top__2lPDn","left":"styles_left__1VyLl","description":"styles_description__3PW4B"};